export const LIST_STYLE = 'list-disc leading-8 pl-8';
